import { render, staticRenderFns } from "./PageInvoiceConfiguration.vue?vue&type=template&id=64b9d539&"
import script from "./PageInvoiceConfiguration.vue?vue&type=script&lang=js&"
export * from "./PageInvoiceConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./PageInvoiceConfiguration.vue?vue&type=style&index=0&id=64b9d539&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports